import i18n from '../i18n'
// API基础配置 - 使用环境变量或默认值
// const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '/api/copyright'//生产环境配置
// const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '/api/copyright'
//测试开发环境
// const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://47.92.54.173:9999/copyright'
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://www.cacopyright.cn/api/copyright'

// 导出API基础地址供其他模块使用
export { API_BASE_URL }

// 附件下载相关工具函数
export const getFullAttachmentUrl = (attachmentPath) => {
  if (!attachmentPath) return ''

  // 确保attachmentPath是字符串类型
  const pathStr = String(attachmentPath)

  // 如果已经是完整URL，直接返回
  if (pathStr.startsWith('http')) {
    return pathStr
  }

  // 确保路径以/开头
  let cleanPath;
  if (pathStr.startsWith('/')) {
    cleanPath = pathStr;
  } else {
    // 检查是否为ID（数字或特定格式的字符串）
    const isId = /^\d+$/.test(pathStr);
    if (isId) {
      // 如果是ID，使用/file?imgId={id}格式
      cleanPath = `/file?imgId=${pathStr}`;
    } else {
      // 如果是路径，使用/file?objectName={path}格式
      cleanPath = `/file?objectName=${pathStr}`;
    }
  }

  // 拼接完整的下载地址
  return `${API_BASE_URL}${cleanPath}`
}

// 处理富文本内容中的图片路径，将相对路径转换为完整URL
export const processRichTextImages = (content) => {
  if (!content || typeof content !== 'string') return content

  // 使用正则表达式匹配富文本中的 img src 属性
  // 处理 src="xxx" 和 src='xxx' 两种格式
  const processedContent = content.replace(
    /src=["']([^"']+)["']/g,
    (match, src) => {
      // 如果已经是完整URL，直接返回
      if (src.startsWith('http') || src.startsWith('//')) {
        return match
      }
      // 转换相对路径为完整URL
      const fullUrl = getFullAttachmentUrl(src)
      return `src="${fullUrl}"`
    }
  )

  return processedContent
}


// 基础请求函数（每次都重新请求，不启用缓存）
export const request = async (url, options = {}) => {
  // 分离缓存相关选项（已禁用缓存，保留以兼容旧调用）和 fetch 选项
  const {
    useCache,
    cacheTTL,
    skipCache,
    ...fetchOptions
  } = options

  // 确定请求方法
  const method = (fetchOptions.method || 'GET').toUpperCase()

  // 确保URL添加/api前缀（如果没有http开头且没有/api前缀）
  let apiUrl = url;
  if (!url.startsWith('http') && !url.startsWith('/api')) {
    apiUrl = `${url.startsWith('/') ? '' : '/'}${url}`;
  }

  const fullUrl = url.startsWith('http') ? url : `${API_BASE_URL}${apiUrl}`

  console.log('🌐 API请求:', fullUrl)

  const defaultOptions = {
    headers: {
      'Content-Type': 'application/json',
      'locale': i18n.language,
    },
  }

  const mergedOptions = {
    ...defaultOptions,
    ...fetchOptions,
    headers: {
      ...defaultOptions.headers,
      ...fetchOptions.headers,
    },
  }

  try {
    const response = await fetch(fullUrl, mergedOptions)

    console.log('📡 API响应状态:', response.status, response.statusText)

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    const text = await response.text()
    // 空响应体（后端对该语言无数据），返回 null 由调用方处理
    if (!text) {
      console.log('⚠️ API响应为空，无数据')
      return null
    }

    const result = JSON.parse(text)

    console.log('✅ API响应数据:', result)

    // 检查业务逻辑成功状态
    if (result.total<0) {
      throw new Error(result.message || '请求失败')
    }

    return result
  } catch (error) {
    console.error('❌ API请求错误:', error)
    throw error
  }
}

// GET请求
// params: URL查询参数
// options: { useCache, cacheTTL, skipCache, headers }
export const get = (url, params = {}, options = {}) => {
  const queryString = Object.keys(params).length > 0
    ? '?' + new URLSearchParams(params).toString()
    : ''

  return request(`${url}${queryString}`, {
    method: 'GET',
    ...options,
  })
}

// POST请求
// data: 请求体数据
// options: { useCache, cacheTTL, skipCache, headers }
export const post = (url, data = {}, options = {}) => {
  return request(url, {
    method: 'POST',
    body: JSON.stringify(data),
    ...options,
  })
}

// PUT请求
// data: 请求体数据
// options: { useCache, cacheTTL, skipCache, headers }
export const put = (url, data = {}, options = {}) => {
  return request(url, {
    method: 'PUT',
    body: JSON.stringify(data),
    ...options,
  })
}

// DELETE请求
// options: { useCache, cacheTTL, skipCache, headers }
export const del = (url, options = {}) => {
  return request(url, {
    method: 'DELETE',
    ...options,
  })
}

export default {
  request,
  get,
  post,
  put,
  delete: del,
  API_BASE_URL,
  getFullAttachmentUrl,
  processRichTextImages
}
